import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { IExpirationSettings } from "@app/shared/expiration-settings/interfaces/expiration-settings.interface";
import { QuotaitonExpirationSettingsApiService } from "../services/quotaiton-expiration-settings-api.service";

export const quotationExpirationSettingsResolver: ResolveFn<IExpirationSettings[]> = (route, _) => {
  const quotationExpirationSettingsApiService = inject(QuotaitonExpirationSettingsApiService);
  return quotationExpirationSettingsApiService.getQuotationExpirationSettings();
};
